"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var questions = (0, _screeners.expandscreeners)([{
  prompt: "Can you start by choosing the values that are most important to you right now? You can choose more than one and after I’ll help you to find a small way to take some action on it.",
  type: "triggerMulti",
  meta: {
    answerLabel: "My values are",
    summaryTitle: "Your important value was…"
  },
  options: ["Self-care", "Attitude / Personal Growth", "Career / Education", "Citizenship or Giving Back", "Finances", "Health / Wellbeing", "Family", "Friendships / Relationships", "Spirituality / Ethics", "Creativity", "Other"],
  batteryId: "VALUES"
}, {
  trigger: "Self-care",
  prompt: "Given that you chose self-care as a value, what is one thing that you could do this week that would be an action based on this value?",
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Self-care was…",
    placeholder: ""
  },
  options: ["Wake up early and do something for myself", "Arrange for some time to myself", "Book myself in for a massage or a health treatment", "Other"],
  batteryId: "VALUES"
}, {
  trigger: "Attitude / Personal Growth",
  prompt: "Given that you chose attitude/personal growth as a value, what is one thing that you could do this week that would be an action based on this value?",
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Attitude / Personal Growth was…",
    placeholder: ""
  },
  options: ["Book myself into a class or a workshop", "Book a coaching session", "Block out some time to read a book or watch a webinar", "Other"],
  batteryId: "VALUES"
}, {
  trigger: "Career / Education",
  prompt: "Given that you chose career/education as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Start an online course", "Book a coaching session", "Ask someone for an informal mentoring session", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Career / Education was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Citizenship or Giving Back",
  prompt: "Given that you chose friendships/relationships as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Research to find good cause via a volunteering website", "Speak with someone in my company about volunteering opportunities", "Volunteer with a local organisation", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Citizenship or Giving Back was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Finances",
  prompt: "Given that you chose finances as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Spend 30 mins on a budget to achieve a financial goal", "Book a session with a financial advisor", "Read a book or watch a webinar related to my financial goals", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Finances was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Health / Wellbeing",
  prompt: "Given that you chose health/wellbeing as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Wake up early to do a small amount of exercise or walk home from work", "Book a session with a health specialist", "Commit to 2 - 4 hours of healthy eating or fasting", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Health / Wellbeing was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Spirituality / Ethics",
  prompt: "Given that you chose spirituality/ethics as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Commit to doing one action aligned with your spiritual or ethical values", "Schedule time to visit a local spiritual, religious or ethical group", "Spend some time in nature or a place that allows you to feel connected", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Spirituality / Ethics was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Family",
  prompt: "Given that you chose family as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Do something with my partner, child or family member that I know means a lot to them", "Time to walk, talk or connect with my partner, child or family member", "Give something to my partner, child or friend that is meaningful to them or me", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Family was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Friendships / Relationships",
  prompt: "Given that you chose friendships/relationships as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Message/call a friend to tell them what I like about them", "Make time to catch up for quality time with someone", "Buy a small gift or a small act of service for someone you care about", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Friendships / Relationships was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Creativity",
  prompt: "Given that you chose creativity growth as a value, what is one thing that you could do this week that would be an action based on this value?",
  options: ["Book myself into a creative class or a workshop", "Wake up early or block out time to spend in a creative pursuit", "Visit an exhibition or an event that gets me creatively inspired", "Other"],
  type: "triggerMultiFollowup",
  meta: {
    summaryTitle: "Your action for Creativity was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, {
  trigger: "Other",
  prompt: "Given that you chose other as a value, what is one thing that you could do this week that would be an action based on this value?",
  type: "textarea",
  meta: {
    answerLabel: "One thing that you could do this week that would be an action based on this value",
    summaryTitle: "Your action for Other was…",
    placeholder: ""
  },
  batteryId: "VALUES"
}, _utils.screeners.HELPFUL]);
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  var summaryItems = [];
  answers["VALUES"][0].forEach(function (value, index) {
    summaryItems.push({
      question: questions[0],
      answer: value
    });
    questions.forEach(function (question, questionIndex) {
      if (question.trigger === value) {
        summaryItems.push({
          question: question,
          answer: answers["VALUES"][questionIndex]
        });
      }
    });
  });
  return summaryItems;
};

exports.getSummaryResults = getSummaryResults;